import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';

import { AlertContent, AlertTitle } from 'assets/styles/sharedStyles';

import AuraUserCard from './user-card';
import AuraSignInPage from './sign-in';
import AuraSplashPage from './splash-page';
import AuraSignOut from './sign-out';

import { messages } from './messages';
import { Container } from './styles';

export const StyledTitle = styled(AlertTitle)`
  padding: 20px 0;
  background-color: #418613;
  color: white;
`;

const AuraContent = styled(AlertContent)`
  background-color: white;
  color: #5e6d70;
`;

const AuraModal = ({ closeAlert = () => {}, user }) => {
  const pages = {
    splash: {
      content: AuraSplashPage,
    },
    signIn: {
      title: <FormattedMessage {...messages.earnWithAura} />,
      content: AuraSignInPage,
      container: AuraContent,
    },
    signInSuccess: {
      title: <FormattedMessage {...messages.congratulations} />,
      content: () => (
        <AuraContent>
          <Container>
            <FormattedMessage {...messages.buildYourAura} />
          </Container>
        </AuraContent>
      ),
      container: AuraContent,
    },
    userCard: {
      content: AuraUserCard,
    },
    signOut: {
      title: <FormattedMessage defaultMessage="Sign Out" />,
      content: AuraSignOut,
      container: AuraContent,
    },
    signOutConfirmation: {
      title: <FormattedMessage defaultMessage="Signed Out" />,
      content: () => (
        <Container>
          <FormattedMessage defaultMessage="You've successfully signed out of your Aura account." />
        </Container>
      ),
      container: AuraContent,
    },
  };

  const [page, setPage] = useState(user ? 'userCard' : 'splash');

  const PageContent = pages[page].content;
  const PageContainer = pages[page].container || AlertContent;

  return (
    <>
      {pages[page].title && <StyledTitle>{pages[page].title}</StyledTitle>}
      <PageContainer>
        <PageContent setPage={setPage} closeAlert={closeAlert} user={user} />
      </PageContainer>
    </>
  );
};

AuraModal.propTypes = {
  closeAlert: PropTypes.func,
  acceptTermsAction: PropTypes.func,
  confirmMethod: PropTypes.func,
  user: PropTypes.shape({
    points: PropTypes.number,
    accountNo: PropTypes.string,
    tier: PropTypes.string,
  }),
};

export default connect(state => ({
  user: state.getIn(['loyalty', 'user'])?.toJS(),
}))(AuraModal);
